<template>
<div style="max-height:80vh; width:100%; overflow:hidden hidden;">
  <v-tabs grow height="64px" color="#399942" background-color="transparent">
    <v-tab class="font-weight-bold text-h6" data-testid="gotoShusei">{{ $t("チャット") }}</v-tab>
    <v-tab class="font-weight-bold text-h6" v-if="project_amdOpen">修正提案</v-tab>

    <!--チャット-->
    <v-tab-item>
      <chat contentType="comments" :pjuid="pjuid" :aboutpj="aboutpj" :pjadmins="pjadmins"></chat>
    </v-tab-item>

    <!--修正提案-->
    <v-tab-item v-if="project_amdOpen">
      <chat contentType="amendments" :pjuid="pjuid" :aboutpj="aboutpj" :pjadmins="pjadmins"></chat>
    </v-tab-item>
  </v-tabs>

  <!--プロフィール画面-->
  <profile_display
    :profile="profile"
    :profuid="profileUid"
    device="pc"
    @closeProfile="closeProfile"
  ></profile_display>

  <!--編集画面-->
  <v-dialog v-model="editPage" width="40%" height="60%" class="pa-8 z1000" @keydown.esc="editPage = false">
    <v-card>
      <v-card-actions>
        <v-card-text class="pa-2">投稿を編集</v-card-text>
        <v-spacer></v-spacer>
        <v-btn icon color="primary" @click="editPage = false"><v-icon color="#E64550">mdi-close</v-icon></v-btn>
      </v-card-actions>
      <v-textarea v-model="editContent" outlined background-color="white" color="#707070" class="pa-4" rows="6" counter
        no-resize v-on:keydown.enter.ctrl.exact="editctrl()"></v-textarea>
      <v-card-actions class="pa-2">
        <v-spacer></v-spacer>
        <v-card-actions class="text-right" width="5%">
          <v-spacer></v-spacer>
          <v-btn class="my-auto mr-2" :disabled="editContent.length<1" style="cursor: pointer; background-color:white" @click="doEditContent() ,editContent='' ,editPage = false" elevation="0">＞訂正</v-btn>                  
        </v-card-actions>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!--削除確認画面-->
  <v-dialog v-model="deleteAlert" width="800" class="z1000">
    <v-card color="white" elevation="15" class="pt-6">
      <v-img class="dog" max-height="100%" max-width="8%" src="../../assets/svg/5007red.svg"></v-img>
      <p class="font-weight-bold pt-6 px-8 text-h5 text-center"><font color="black">本当にこの<span v-if="contentType==='comm'">コメント</span><span v-if="contentType==='amend'">修正提案</span>を削除しますか？</font></p>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-chip class="ma-4 pa-4 font-weight-bold" @click="deleteAlert = false, doDeleteContent()" color="#66baff" dark>はい</v-chip>
        <v-chip class="ma-4 pa-4 font-weight-bold" @click="deleteAlert = false" color="#E64550" dark>いいえ</v-chip>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!--サインイン画面-->
  <v-dialog v-model="authModal" width="400px" height="60%" class="z1000">
    <auth-view
      v-if="authModal"
      defaultView="chooseauth"
      @closeModal="closeAuthModal"
    >
    </auth-view>
  </v-dialog>

  <activity_function ref="activityfunc" />
</div>
</template>

<script>
import Vue from 'vue'
import firebase from "firebase/app"
import "firebase/firestore"
import VueDOMPurifyHTML from 'vue-dompurify-html'
import chat from './chat.vue'
import authView from '../auth/authView.vue';
import activity_function from '../../components/profile/activity_function.vue'
import profile_display from "../../components/profile/profile_display.vue";
Vue.use(VueDOMPurifyHTML)
export default{
  components:{
    authView,
    activity_function,
    profile_display,
    chat
  },
  mounted(){
    this.db = firebase.firestore() // dbインスタンスを初期化
    this.today()
    this.comment=""
    this.amendment=""
    this.getIconDict()
  },
  props:{
    pjuid: String,
    aboutpj: Object,
    pjadmins: Array,
  },
  data: (vm) => ({
    db: null,
    offsetTop: 0,
    offset: true,
    //dialog
    editPage: false,
    deleteAlert: false,
    LidSankaAlert: false,

    //comm
    contentType: "comm",
    comment: "",
    amendment: "",
    contentUid: "",
    editContent: "",
    commlike: [],
    amendlike: [],
    isAnonymity: false,
    anonymitys: [],
    isReply: false,
    replyContent: "",
    replyId: "",
    isMention: false,
    mentionId: "",
    timeday: "",
    authModal:false,
    profImageDict: {},
    profile: false,
    profileUid: "",
  }),
  computed:{
    namelist(){
      return this.$store.state.namelist
    },
    isAdmin() {
      return this.$store.state.isAdmin;
    },
    pjusers() {
      return this.$store.state.pjusers;
    },
    uid() {
      return this.$store.state.auth?.user?.uid || '';
    },
    isAuthed() {
      return this.$store.state.auth?.isAuthed;
    },
    lid(){
      return this.$store.state.lid
    },
    alid(){
      return this.$store.state.alid
    },
    aboutLid() {
      return this.$store.state.aboutLid
    },
    project_amdOpen() {
      if(this.$store.state.config.setting&&this.$store.state.config.setting.project_amdOpen) return !this.$store.state.config.setting.project_amdOpen
      else return true
    },
    baseAdmins(){
      return this.$store.state.admins
    },
  },
  methods: {
    closeAuthModal() {
      this.authModal = false
    },
    toDoubleDigits(num) {
      num += "";
      if (num.length === 1) {
        num = "0" + num;
      }
      return num; 
    },
    today(){
      // 日付をYYYY/MM/DD HH:DD:MI:SS形式で取得
      let date = new Date();
      let yyyy = date.getFullYear();
      let mm = this.toDoubleDigits(date.getMonth() + 1)
      let dd = this.toDoubleDigits(date.getDate())
      let hh = this.toDoubleDigits(date.getHours())
      let mi = this.toDoubleDigits(date.getMinutes())
      let se = this.toDoubleDigits(date.getSeconds())
      let ms = this.toDoubleDigits(date.getMilliseconds())
      this.todayy = yyyy + mm + dd + hh + mi + se + ms
      this.timeday= mm+"/"+dd
      this.timehour= hh+":"+mi
    },
    getIconDict() {
      let collection = this.db.collection("0").doc("config").collection("members")
      let self = this
      collection.onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          // console.log("icon: ", change.doc.data().uid,change.doc.data().profImageO)
          if (change.doc.data().profImageO != "") self.profImageDict[change.doc.data().uid] = change.doc.data().profImageO;
        })
      });
      // console.log(this.profImageDict)
    },
    closeProfile() {
      this.profile = false;
    }
  }
}
</script>

<style scoped>
.dog{
  position: absolute;
  top: 20%;
  left: 5%;
}
.tab1{
  font-weight: 800;
  width: 33%;
}
.dotbtn{
  position: absolute;
  top: 10%;
  right: 1%;
  display: flex;
	align-items: center;
}
*{
  font-family:mplus-2c-medium;
}
::-webkit-scrollbar {
  display: none;
}
/*
::-webkit-scrollbar-track {
background-color: rgba(120, 170, 210,0.3);
border-radius: 100px;
}
::-webkit-scrollbar-thumb {
background: #78aad2;
border-radius: 100px;
width: 130px;
}
*/
</style>